<template>
  <nav :class="utid == (4 || 3) ? 'nav-inactive' : 'nav-active'">
    <a v-click-outside="hide" @click="toggle" class="toggle-menu sa-h-sm-up">
      <span :class="open ? 'active' : 'inactive'" class="icon-menu-bar"></span>
    </a>
    <span class="sa-active sa-h-sm-up" v-if="utid !== (4 || 3)"
      >Inactive <i class="icon-info"></i
    ></span>
    <component
      :is="navigate && !hideMenu ? 'router-link' : 'button'"
      :to="navigate && !hideMenu ? '/dashboard' : undefined"
      class="sa-logo"
    >
      <img
        src="https://img.litedev.com/images/static/logo.svg"
        alt="Logo"
        class="sa-h-sm"
      />
      <!-- <i class="icon-logo-symbol sa-h-lg-down"></i> -->
    </component>
    <transition slide="right" type="animation" name="slide">
      <ul v-if="!hideMenu" class="sa-nav" :class="open ? 'active' : 'inactive'">
        <component
          ref="ref"
          :is="navigate ? 'router-link' : 'button'"
          :class="item.class"
          :tag="navigate ? 'li' : undefined"
          v-for="(item, i) in menuItem"
          :key="i"
          :to="navigate ? item.path : undefined"
          @click.native="item.info == 'Log Out' ? logoutPopup(item.info) : '#'"
        >
          <a class="sa-nav-link"
            ><i v-bind:class="item.icon" class="sa-nav-link-icon"></i>
            <span class="sa-h-sm">{{ item.info }}</span>
            <small class="sa-noti-count">{{ notificationCount }}</small>
          </a>
        </component>
      </ul>
    </transition>
    <logout-Popup v-show="logoutYes" v-on:logout="logout"></logout-Popup>
  </nav>
</template>

<script>
import ClickOutside from "vue-click-outside";
import Logout from "./LogOut";
import { com_url, oh_url } from "../../../config/endpoints";
import { bus } from "../../main";
import { LOGOUT } from "../../util/constants";
export default {
  computed: {
    notificationCount: function() {
      return this.$store.getters.getNotificationCount;
    },
  },
  data() {
    return {
      countNo: 0,
      ref: 1,
      navigate: false,
      hideMenu: false,
      open: false,
      activeIndex: 0,
      logoutYes: false,
      menuItem: [
        {
          class: "sa-dashb",
          icon: "icon-dashboard",
          path: "/dashboard",
          info: "Dashboard",
        },
        {
          class: "sa-prof",
          icon: "icon-user2",
          path: "/profile",
          info: "Profile",
        },
        {
          class: "sa-apt",
          icon: "icon-appointment",
          path: "/appointments",
          info: "Appointments/Consultation",
        },
        {
          class: "sa-scd",
          icon: "icon-schedule",
          path: "/schedule",
          info: "Schedule",
        },
        // {class:'sa-rep', icon: "icon-report", path: "/reports", info: "Reports/Analysis", },
        {
          class: "sa-rep",
          icon: "icon-report",
          path: "/reportsv1",
          info: "Reports/Analysis",
        },
        {
          class: "sa-acc",
          icon: "icon-accounts",
          path: "/accounts",
          info: "Accounts",
        },
        {
          class: "sa-noti",
          icon: "icon-ring",
          path: "/notification",
          info: "Notification",
        },
        {
          class: "sa-con",
          icon: "icon-ontactus",
          path: "/contactus",
          info: "Contact Us",
        },
        {
          class: "sa-set",
          icon: "icon-settings",
          path: "/settings",
          info: "Settings",
        },
        {
          class: "sa-priv",
          icon: "icon-privacypolicy",
          path: "/privacy-policy",
          info: "Privacy Policy",
        },
        {
          class: "sa-term",
          icon: "icon-privacypolicy",
          path: "/terms-and-conditions",
          info: "Terms and Conditions",
        },
        {
          class: "sa-rateandreview",
          icon: "icon-star-review",
          path: "/rate-and-review",
          info: "Rate and Review",
        },
        // {
        //     class: 'sa-nurse',
        //     icon: "icon-nurse",
        //     path: "/my-appointments",
        //     info: "My Appointments",
        // },
        // {
        //     class: 'sa-labtechnician',
        //     icon: "icon-nurse",
        //     path: "/lab-technician",
        //     info: "Lab Technician",
        // },
        {
          class: "sa-log",
          icon: "icon-logout",
          path: "#",
          info: "Log Out",
        },
      ],
    };
  },
  created() {
    this.utid = JSON.parse(this.$localStorage.get("utid"));
  },
  methods: {
    countData(countNo) {
      if (countNo == 0) {
        return 0;
      } else {
        this.countNo++;
      }
    },
    notiCount() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${oh_url}/pro/notification/count`,
        })
        .then((response) => {
          if (response && response.status === 1000 && response.data) {
            _self.$store.dispatch(
              "SET_NOTIFICATION_COUNT",
              response.data.count || 0
            );
          }
        });
    },
    init() {
      this.utid = JSON.parse(this.$localStorage.get("utid"));
      if (this.utid == "3" || this.utid == "4") {
        this.menuItem = [
          {
            class: "sa-apt",
            icon: "icon-appointment",
            path: "/appointments",
            info: "Appointments/Consultation",
          },
          {
            class: "sa-noti",
            icon: "icon-ring",
            path: "/notification",
            info: "Notification",
          },
          {
            class: "sa-log",
            icon: "icon-logout",
            path: "#",
            info: "Log Out",
          },
        ];
      } else {
        this.menuItem = [
          {
            class: "sa-dashb",
            icon: "icon-dashboard",
            path: "/dashboard",
            info: "Dashboard",
          },
          {
            class: "sa-prof",
            icon: "icon-user2",
            path: "/profile",
            info: "Profile",
          },
          {
            class: "sa-apt",
            icon: "icon-appointment",
            path: "/appointments",
            info: "Appointments/Consultation",
          },
          {
            class: "sa-scd",
            icon: "icon-schedule",
            path: "/schedule",
            info: "Schedule",
          },
          // {class:'sa-rep', icon: "icon-report", path: "/reports", info: "Reports/Analysis", },
          {
            class: "sa-rep",
            icon: "icon-report",
            path: "/reportsv1",
            info: "Reports/Analysis",
          },
          {
            class: "sa-acc",
            icon: "icon-accounts",
            path: "/accounts",
            info: "Accounts",
          },
          {
            class: "sa-noti",
            icon: "icon-ring",
            path: "/notification",
            info: "Notification",
          },
          {
            class: "sa-con",
            icon: "icon-ontactus",
            path: "/contactus",
            info: "Contact Us",
          },
          {
            class: "sa-set",
            icon: "icon-settings",
            path: "/settings",
            info: "Settings",
          },
          {
            class: "sa-priv",
            icon: "icon-privacypolicy",
            path: "/privacy-policy",
            info: "Privacy Policy",
          },
          {
            class: "sa-term",
            icon: "icon-privacypolicy",
            path: "/terms-and-conditions",
            info: "Terms and Conditions",
          },
          {
            class: "sa-rateandreview",
            icon: "icon-star-review",
            path: "/rate-and-review",
            info: "Rate and Review",
          },
          // {
          //     class: 'sa-nurse',
          //     icon: "icon-nurse",
          //     path: "/my-appointments",
          //     info: "Nurse",
          // },
          // {
          //     class: 'sa-labtechnician',
          //     icon: "icon-nurse",
          //     path: "/lab-technician",
          //     info: "Lab Technician",
          // },
          {
            class: "sa-log",
            icon: "icon-logout",
            path: "#",
            info: "Log Out",
          },
        ];
      }
      let userInfo = JSON.parse(this.$localStorage.get("userdata"));
      if (userInfo && userInfo.eid !== "HSP1" && userInfo.eid !== "HSP0") {
        this.menuItem = this.menuItem.filter((item) => item.info != "Accounts");
      }
      // if(userInfo && !userInfo.show_referral_screens) {
      // 	this.menuItem = this.menuItem.filter(item => ((item.info != 'Reports/Analysis')));
      // }
      if (userInfo && !userInfo.pro_rating) {
        this.menuItem = this.menuItem.filter(
          (item) => item.info != "Rate and Review"
        );
      }
      this.ref = this.ref + 1;
    },
    hide() {
      this.open = false;
    },
    toggle() {
      this.open = !this.open;
    },
    logoutPopup() {
      this.open = !this.open;
      this.logoutYes = true;
    },
    logout(e) {
      let _self = this;
      if (e == "Log Out") {
        this.logoutYes = false;
        // revoke fcm token
        // delete fcm token from db
        _self.$store
          .dispatch("httpPost", {
            uri: `${com_url}/fcm/delete`,
            body: {
              fcmt: _self.$store.state.fcmt,
            },
          })
          .then((resp) => {
            console.log("resp", resp);
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$store.dispatch("SET_NAVIGATE", false);
            _self.$store.dispatch("SET_USER", null);
            _self.$store.dispatch("SET_FCMTTOKEN", null);
            _self.$router.push({
              path: "/",
            });
            // disconnect socket connection
            bus.$emit(LOGOUT);
          });
      }
    },
  },
  mounted: function() {
    this.popupItem = this.$el;
    this.init();
    this.notiCount();
    this.countNo++;
  },
  directives: {
    ClickOutside,
  },
  components: {
    "logout-Popup": Logout,
  },
  watch: {
    "$store.state.navigate": {
      immediate: true,
      deep: true,
      handler() {
        this.navigate = this.$store.state.navigate;
      },
    },
    "$store.state.userdata": {
      immediate: true,
      deep: true,
      handler() {
        this.init();
      },
    },
    "$store.state.hideMenu": {
      immediate: true,
      deep: true,
      handler() {
        this.hideMenu = this.$store.state.hideMenu;
      },
    },
  },
};
</script>
